var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      staticClass: "customfields-modal",
      attrs: {
        visible: _vm.showModal,
        size: "small",
        title: _vm.$t.__(
          "thirds.thirdscomponents.CustomFieldsModal.add_custom_field"
        )
      },
      on: {
        "update:visible": function($event) {
          _vm.showModal = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("div", { staticClass: "dialog__default" }, [
          _c(
            "section",
            _vm._l(_vm.availablesGroupFields, function(group, index) {
              return _c("custom-fields-group", {
                key: group.id,
                class: {
                  "mb-4": index !== _vm.availablesGroupFields.length - 1
                },
                attrs: { group: group, currentStore: _vm.currentStore },
                on: { fieldsUpdated: _vm.handleFieldsUpdated }
              })
            }),
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("template", { slot: "footer" }, [
        _c(
          "div",
          { staticClass: "dialog__footer" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.cancel"),
                type: "secondary",
                "data-bot": _vm.getDatabot(
                  "btn-cancel",
                  _vm.currentStore,
                  null,
                  "cf-popup"
                )
              },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              staticClass: "ml-2",
              attrs: {
                label: _vm.$t.__("common.actions.add"),
                type: "primary",
                "data-bot": _vm.getDatabot(
                  "btn-save",
                  _vm.currentStore,
                  null,
                  "cf-popup"
                )
              },
              on: { click: _vm.addFields }
            })
          ],
          1
        )
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }